module.exports = __webpack_public_path__ + "img/tarj1-3.5d0aba1b.svg";